import { User } from "../../../../../interfaces/User";

export function createMailWithSubscribed(dataTableUsers: [], edition: any) {
  let baseURL = "https://outlook.office.com/mail/deeplink/compose?to=";

  let userEmails = dataTableUsers.map((user: User) => user.email).join(",");

  const facultyEmails = edition.sessions
    .flatMap((session: any) =>
      (session.faculties || []).map((f: any) => f.email),
    )
    .filter(Boolean)
    .join(",");

  const tutorEmails = edition.sessions
    .flatMap((session: any) => (session.tutors || []).map((t: any) => t.email))
    .filter(Boolean)
    .join(",");

  const otherEmails = [facultyEmails, tutorEmails].filter(Boolean).join(",");

  const allEmails = [userEmails, otherEmails].filter(Boolean).join(",");

  return baseURL + allEmails;
}
